import {AppWindow} from "@/types";
import Keycloak from 'keycloak-js';

export function setKeycloak(keycloak: Keycloak.KeycloakInstance) {
  // @ts-ignore
  (window as AppWindow).Keycloak = keycloak
}

export function getKeycloak(): Keycloak.KeycloakInstance {
  // @ts-ignore
  return (window as AppWindow).Keycloak
}


// WEBPACK FOOTER //
// ./src/components/auth/keycloak.ts